import React, { useState, useEffect } from "react";
import { Tabs, Table } from "antd";
import { CURRENCY } from "Constants/";
import moment from "moment";
import { formatCurrency } from "Utils";

const { TabPane } = Tabs;

export default function CashFlowSummary({ cashflow = [], ...props }) {
  const [total, setTotal] = useState([]);
  const [subTotal, setSubTotal] = useState([]);
  useEffect(() => {
    if (cashflow && cashflow.length > 0) {
      const total = [
        ...cashflow
          .reduce((map, item) => {
            const { type: key, documentAmount } = item;
            const prev = map.get(key.id);

            if (prev) {
              prev.documentAmount += documentAmount;
            } else {
              map.set(key.id, Object.assign({}, item));
            }

            return map;
          }, new Map())
          .values(),
      ];

      setTotal(total);

      const subTotal = [
        ...cashflow
          .reduce((map, item) => {
            let key = `${item.type.description}-${moment(
              item.dateOfMaturity
            ).format("YYYY")}`;
            const prev = map.get(key);

            if (prev) {
              prev.documentAmount += item.documentAmount;
            } else {
              map.set(
                key,
                Object.assign({}, item, {
                  year: moment(item.dateOfMaturity).format("YYYY"),
                })
              );
            }

            return map;
          }, new Map())
          .values(),
      ];

      setSubTotal(subTotal);
    }
  }, [cashflow]);

  return (
    <Tabs defaultActiveKey={1}>
      <TabPane tab="Ara Toplam" key={1}>
        <Table
          size="small"
          bordered
          dataSource={subTotal}
          columns={[
            {
              title: "Koşul Türü",
              dataIndex: ["type", "description"],
              sorter: (a, b) => a.type.description - b.type.description,
            },
            {
              title: "Yıl",
              dataIndex: "year",
              sorter: (a, b) => a.year - b.year,
            },
            {
              title: "Tutar",
              dataIndex: "documentAmount",
              sorter: (a, b) => a.documentAmount - b.documentAmount,
              render: (text, record) =>
                formatCurrency(record.documentAmount, record.documentCurrency),
            },
          ]}
          pagination={false}
        />
      </TabPane>
      <TabPane tab="Genel Toplam" key={2}>
        <Table
          size="small"
          bordered
          rowKey={(row) => row.type.id}
          dataSource={total}
          columns={[
            {
              title: "Koşul Türü",
              dataIndex: ["type", "description"],
              sorter: (a, b) => a.type.description - b.type.description,
            },
            {
              title: "Tutar",
              dataIndex: "documentAmount",
              sorter: (a, b) => a.documentAmount - b.documentAmount,
              render: (text, record) =>
                formatCurrency(record.documentAmount, record.documentCurrency),
            },
          ]}
          pagination={false}
        />
      </TabPane>
    </Tabs>
  );
}
